import styled from 'styled-components';
import { Loader, Tab } from 'semantic-ui-react';
import { useState } from 'react';
import { Check } from '@phosphor-icons/react';
import { MuteText } from '../../elements';
import { ExportInvoiceServiceTab } from './ExportInvoiceTabs/ServiceTab';
import { ExportInvoicePackageTab } from './ExportInvoiceTabs/PackagesTab';
import { ExportInvoiceCustomerTab } from './ExportInvoiceTabs/CustomerTab';
import { fieldTypes } from './ExportInvoiceElements/common';
import { CommonUtility, theme } from '../../utility';

const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledLoader = styled(Loader)`
  &::before {
    border-color: rgba(0, 0, 0, 0.1) !important;
  }
`;

export function ExportInvoicesTab({
  addField,
  customerFormValue,
  deleting,
  formValues,
  onFormChange,
  onQuickBookFieldChange,
  packagingMaterialFormValue,
  quickBookConfig,
  quickBookConfigLoading,
  removeField,
  serviceFields,
  setCustomerFormValue,
  setExpand,
  setPackagingMaterialFormValue,
  setShowEditView,
  showEditView,
  triggerFieldChange,
  updatingConfig,
  showLoader,
}) {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleTabChange = (e, { activeIndex }) => {
    setShowEditView(false);
    setActiveIndex(activeIndex);
  };

  const commonProps = {
    showEditView,
    setShowEditView,
    deleting,
  };

  const onChangePackagingMaterialValue = (packagingId, key, value) => {
    setPackagingMaterialFormValue(packagingMaterialFormValue => ({
      ...packagingMaterialFormValue,
      [packagingId]: {
        ...packagingMaterialFormValue[packagingId],
        [key]: value,
      },
    }));
    triggerFieldChange();
  };

  const onChangeCustomerValue = (customerId, key, value) => {
    setCustomerFormValue(customerFormValue => ({
      ...customerFormValue,
      [customerId]: {
        ...customerFormValue[customerId],
        [key]: value,
      },
    }));
    triggerFieldChange();
  };

  const onAddCustomer = (customerId, name) => {
    if (CommonUtility.isValidObject(customerFormValue[customerId])) return;

    setCustomerFormValue(customerFormValue => ({
      ...customerFormValue,
      [customerId]: {
        name,
      },
    }));
  };

  const onAddPackaginMaterial = (packagingId, name) => {
    if (CommonUtility.isValidObject(packagingMaterialFormValue[packagingId])) return;

    setPackagingMaterialFormValue(packagingMaterialFormValue => ({
      ...packagingMaterialFormValue,
      [packagingId]: {
        name,
      },
    }));
  };

  const panes = [
    {
      menuItem: 'Services',
      name: 'services',
      render: () => (
        <ExportInvoiceServiceTab
          quickBookConfigLoading={quickBookConfigLoading}
          formValues={formValues}
          onFormChange={onFormChange}
          serviceFields={serviceFields}
          onQuickBookFieldChange={onQuickBookFieldChange}
          removeField={fieldToRemove => removeField(fieldToRemove, fieldTypes.service)}
          quickBookConfig={quickBookConfig}
          addField={addField}
          triggerFieldChange={triggerFieldChange}
          {...commonProps}
        />
      ),
    },
    {
      menuItem: 'Packages',
      name: 'packages',
      render: () => (
        <ExportInvoicePackageTab
          {...commonProps}
          removeField={fieldToRemove => removeField(fieldToRemove, fieldTypes.packages)}
          addField={onAddPackaginMaterial}
          formValue={packagingMaterialFormValue}
          onFormChange={onChangePackagingMaterialValue}
        />
      ),
    },
    {
      menuItem: 'Customers',
      name: 'customers',
      render: () => (
        <ExportInvoiceCustomerTab
          {...commonProps}
          removeField={fieldToRemove => removeField(fieldToRemove, fieldTypes.customers)}
          addField={onAddCustomer}
          formValue={customerFormValue}
          onFormChange={onChangeCustomerValue}
        />
      ),
    },
  ];

  return (
    <div>
      <Field>
        <div className="d-flex align-items-center ">
          <b>QuickBooks Configuration</b>
          {(updatingConfig || showLoader) && (
            <>
              {updatingConfig ? (
                <StyledLoader active inline size="mini" className="ml-2 mb-1" />
              ) : (
                <Check className="ml-1" weight="bold" color={theme.colors.green} />
              )}
            </>
          )}
        </div>
        <MuteText>
          Enter custom display names for how these services should appear in QuickBooks.
        </MuteText>
      </Field>
      <Tab
        activeIndex={activeIndex}
        onTabChange={handleTabChange}
        menu={{ secondary: true, pointing: true }}
        panes={panes}
        onClick={() => setExpand(false)}
      />
    </div>
  );
}
